import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class SharedMessageService {
    
  private nameSource = new BehaviorSubject<PriorityItem[]>([]);
  currentNames = this.nameSource.asObservable();

  changeName(newItem: PriorityItem) {
    const currentItems = this.nameSource.getValue();
    const index = currentItems.findIndex(item => item.code === newItem.code);
    if (index !== -1) {
      currentItems[index] = newItem;
    } else {
      currentItems.push(newItem);
    }
    this.nameSource.next(currentItems);
  }

  constructor() { }

  convertValue(value: string): string {
    const valueMap: { [key: string]: string } = {
        "STD": "Standard",
        "RUSH2": "Rush",
        "RUSH3": "Top"
    };

    return valueMap[value] || "Standard";
  }


isPriorityMismatch(orderLevelPriority: string, sampleOrderLevelPriority:string) {
  if (sampleOrderLevelPriority == null || sampleOrderLevelPriority == 'undefined' || sampleOrderLevelPriority == 'None') {
    return true;
  }
  
  return orderLevelPriority == sampleOrderLevelPriority;
}
}

export interface PriorityItem {
  priority: string;
  code: string;
}
